import { ArrowLeft, FileText, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-2" /> Torna indietro
        </Button>

        <div className="bg-white rounded-2xl shadow-lg p-8">
          <div className="flex items-center gap-3 mb-6">
            <FileText className="w-8 h-8 text-indigo-600" />
            <h1 className="text-3xl font-bold text-gray-900">Termini di Servizio</h1>
          </div>
          
          <p className="text-sm text-gray-500 mb-8">
            Ultimo aggiornamento: Gennaio 2025
          </p>

          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                📝 In parole semplici
              </h2>
              <p className="text-lg leading-relaxed">
                Your Life Map è un'app per organizzarti e migliorare le tue abitudini. 
                Usala con buon senso, rispetta gli altri, e noi faremo del nostro meglio 
                per farti funzionare tutto bene.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                ✅ Cosa puoi fare
              </h2>
              <ul className="space-y-2 text-base">
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-1">✓</span>
                  <span>Usare l'app per organizzare la tua vita personale</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-1">✓</span>
                  <span>Tracciare abitudini, spese, umore e tutto il resto</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-1">✓</span>
                  <span>Esportare i tuoi dati quando vuoi</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-1">✓</span>
                  <span>Cancellare il tuo account in qualsiasi momento</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                🚫 Cosa NON puoi fare
              </h2>
              <ul className="space-y-2 text-base">
                <li className="flex items-start gap-2">
                  <span className="text-red-500 mt-1">✗</span>
                  <span>Usare l'app per scopi illegali</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-500 mt-1">✗</span>
                  <span>Tentare di accedere ai dati di altri utenti</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-500 mt-1">✗</span>
                  <span>Sovraccaricare i server con richieste automatizzate</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-500 mt-1">✗</span>
                  <span>Copiare o rivendere l'app</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                💳 Pagamenti e Abbonamenti
              </h2>
              <ul className="space-y-2 text-base">
                <li className="flex items-start gap-2">
                  <span className="text-blue-500 mt-1">•</span>
                  <span>I prezzi sono indicati al momento dell'acquisto</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-500 mt-1">•</span>
                  <span>Puoi cancellare l'abbonamento in qualsiasi momento</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-500 mt-1">•</span>
                  <span>La cancellazione ha effetto dal ciclo di fatturazione successivo</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-500 mt-1">•</span>
                  <span>Non sono previsti rimborsi per periodi già pagati</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                ⚠️ Limitazioni di responsabilità
              </h2>
              <p className="text-base leading-relaxed mb-3">
                Facciamo del nostro meglio, ma:
              </p>
              <ul className="space-y-2 text-base">
                <li className="flex items-start gap-2">
                  <span className="text-amber-500 mt-1">!</span>
                  <span>L'app è fornita "così com'è", senza garanzie assolute</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-amber-500 mt-1">!</span>
                  <span>Non siamo responsabili per perdite di dati causate da eventi fuori dal nostro controllo</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-amber-500 mt-1">!</span>
                  <span>I consigli nell'app sono informativi, non sostituiscono pareri professionali (medici, psicologi, finanziari)</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                🔄 Modifiche ai termini
              </h2>
              <p className="text-base leading-relaxed">
                Potremmo aggiornare questi termini. Se le modifiche sono importanti, 
                ti avviseremo via email o con una notifica nell'app. 
                Continuando a usare l'app dopo le modifiche, accetti i nuovi termini.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                ⚖️ Legge applicabile
              </h2>
              <p className="text-base leading-relaxed">
                Questi termini sono regolati dalla legge italiana. 
                Per qualsiasi controversia, faremo del nostro meglio per risolverla 
                in modo amichevole prima di ricorrere alle vie legali.
              </p>
            </section>

            <section className="bg-indigo-50 rounded-xl p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-3 flex items-center gap-2">
                <Mail className="w-5 h-5 text-indigo-600" />
                Contatti
              </h2>
              <p className="text-base leading-relaxed">
                Per domande sui termini di servizio:
              </p>
              <p className="mt-3 font-medium">
                Laura Piccinini<br />
                <a href="https://www.laurapiccinini.it" className="text-indigo-600 hover:underline">
                  www.laurapiccinini.it
                </a>
                {" • "}
                <a href="https://www.psicoapplicata.org" className="text-indigo-600 hover:underline">
                  www.psicoapplicata.org
                </a>
              </p>
            </section>
          </div>
        </div>

        <p className="text-center text-sm text-gray-400 mt-8">
          Your Life Map © 2025 - Tutti i diritti riservati
        </p>
      </div>
    </div>
  );
};

export default TermsPage;
